<script>
	import { Route } from "tinro";
	import Transition from "./components/Transition.svelte";

	import ContentCategory from "./pages/contents/CategoryContents.svelte";
	import ContentNotices from "./pages/contents/Notice.svelte";
	import ContentMusicsSleeps from "./pages/contents/MusicSleeps.svelte";
	import ContentMeditationMusics from "./pages/contents/MeditationMusics.svelte";
	import ContentMusicFocus from "./pages/contents/FocusMusics.svelte";
	import ContentSoundSignals from "./pages/contents/SoundSignals.svelte";
	import ContentSoundSources from "./pages/contents/SoundSources.svelte";
	import ContentSoundMusics from "./pages/contents/SoundMusics.svelte";
	import ContentAiReportPrompt from "./pages/contents/AiReportPrompt.svelte";
	import VersionApp from "./pages/version/App.svelte";
	import VersionAlgorithm from "./pages/version/Algorithm.svelte";
	import VersionFirmware from "./pages/version/Firmware.svelte";
		import DeviceDistribution from "./pages/device/Distribution.svelte";
	import DeviceManagement from "./pages/device/Management.svelte";
	import UserManagement from "./pages/user/Management.svelte";
	import AdminManagement from "./pages/admin/Management.svelte";
	import LogApi from "./pages/log/LogApi.svelte";
	import LogApp from "./pages/log/LogApp.svelte";
	import Test from "./pages/email/MailSendTest.svelte";
	import MailSendTest from "./pages/email/MailSendTest.svelte";
	import MqttMonitor from "./pages/monitor/MqttMonitor.svelte";
	import MqttLogs from "./pages/monitor/MqttLogs.svelte";
	import SamsungSessions from "./pages/samsung/Sessions.svelte";
	import SamsungCompare from "./pages/samsung/Compare.svelte";
	import SamsungLights from "./pages/samsung/Lights.svelte";
	import SamsungStatistics from "./pages/samsung/Statistics.svelte";

	const routes = [
		{
			path: "/contents/category/contents",
			component: ContentCategory,
		},
		{
			path: "/contents/notices",
			component: ContentNotices,
		},
		{
			path: "/contents/musics/sleeps",
			component: ContentMusicsSleeps,
		},
		{
			path: "/contents/musics/meditations",
			component: ContentMeditationMusics,
		},
		{
			path: "/contents/musics/focus",
			component: ContentMusicFocus,
		},
		{
			path: "/contents/sound/signals",
			component: ContentSoundSignals,
		},
		{
			path: "/contents/sound/sources",
			component: ContentSoundSources,
		},
		{
			path: "/contents/sound/musics",
			component: ContentSoundMusics,
		},
		{
			path: "/contents/ai-report-prompt",
			component: ContentAiReportPrompt,
		},
		{
			path: "/version/app",
			component: VersionApp,
		},
		{
			path: "/version/algorithm",
			component: VersionAlgorithm,
		},
		{
			path: "/version/firmware",
			component: VersionFirmware,
		},
		{
			path: "/device/distribution",
			component: DeviceDistribution,
		},
		{
			path: "/device/management",
			component: DeviceManagement,
		},
		{
			path: "/user/management",
			component: UserManagement,
		},
		{
			path: "/admin/management",
			component: AdminManagement,
		},
		{
			path: "/log/api",
			component: LogApi,
		},
		{
			path: "/log/app",
			component: LogApp,
		},
		{
			path: "/email/test",
			component: MailSendTest,
		},
		{
			path: "/monitor/mqtt",
			component: MqttMonitor,
		},
		{
			path: "/monitor/mqtt-logs",
			component: MqttLogs,
		},
		{
			path: "/samsung/sessions",
			component: SamsungSessions,
		},
		{
			path: "/samsung/compare/:id",
			component: SamsungCompare,
		},
		{
			path: "/samsung/lights/:id",
			component: SamsungLights,
		},
		{
			path: "/samsung/statistics",
			component: SamsungStatistics,
		},
	];

	// 메인 리다이렉트 경로
	const DEFAULT_ROUTE = "/monitor/mqtt";
</script>

<Transition>
	<!-- 메인 리다이렉트 -->
	<Route path="/" redirect={DEFAULT_ROUTE}>
		<ContentCategory />
	</Route>

	<!-- 정의된 라우트들 -->
	{#each routes as { path, component: Component }}
		<Route {path}>
			<Component />
		</Route>
	{/each}

	<!-- 404 페이지 -->
	<Route fallback>
		<div class="error-page">
			<h1>페이지를 찾을 수 없습니다</h1>
			<a href={DEFAULT_ROUTE}>메인으로 돌아가기</a>
		</div>
	</Route>
</Transition>

<style>
	.error-page {
		text-align: center;
		padding: 2rem;
	}
	.error-page a {
		color: #0d6efd;
		text-decoration: none;
	}
</style>
